import React, { useMemo, useState, useEffect } from "react";
import he from "he";
import "./MissionSection.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";


const LeftImageSection = () => {
 const [whoWeAreContent, setWhoWeAreContent] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.who_we_are_section) {
        setWhoWeAreContent(he.decode(page.data.who_we_are_section.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(whoWeAreContent), [whoWeAreContent]);
  
    return (
      <div>
        {processedContent && (
          <div className="whoWeAre" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };


export default LeftImageSection;
